import { select,call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import {initialState,ASYNC_SAVE_LICENSE, SAVE_LICENSE_SUCCESS, ASYNC_READ_LICENSE, READ_LICENSE_SUCCESS, CHECK_AMT_SUCCESS, ASYNC_CHECK_AMT, UPDATE_LICENSE_EDIT, ASYNC_ADD_LICENSEPAY, ADD_LICENSEPAY_SUCCESS} from '../redux/ducks/licenseEditDuck'
import { AddLicensePayment, CheckLicenseAmt, CreatLicense, EditLicense,ReadLicense ,ExtendLicense, parseStdResponseError} from '../server/WebServiceUrl';
import Axios from 'axios';


async function axiosCreateLicense(licenseData){
  let result = {
    data:{}
  };
    try{
      result = await Axios.put(CreatLicense,licenseData);     
    }catch(e){
      if(e.response){
        result.data = e.response.data;
      }  
      
    }
    return result.data;
  }

async function axiosEditLicense(licenseData){    
  let result = {
    data:{}
  };
    try{
      result = await Axios.post(EditLicense,licenseData);     
    }catch(e){
      if(e.response){
        result.data = e.response.data;
      }  
      //console.log(e);
    }    
    return result.data;
  }

  async function axiosReadLicense(code){
    let result = {};
    try{
      result = await Axios.get(ReadLicense,{params:{code:code}});     
    }catch(e){
      if(e.response){
        result.data = e.response.data;
      }  
    }
    return result;
  }

  async function axiosCheckLicenseAmt(licenseData){
    let result = {
      data:{}
    };
    try{
      result = await Axios.post(CheckLicenseAmt,licenseData);     
    }catch(e){
      if(e.response){
        result.data = e.response.data;
      }  
    }
    return result.data;
  }

  async function axiosAddPayment(uuid, paymentMethod){
    let licenseData = {
      uuid,
      paymentMethod
    }
    let result = {
      data:{}
    };
    try{
      result = await Axios.post(AddLicensePayment,licenseData);     
    }catch(e){
      if(e.response){
        result.data = e.response.data;
      }  
    }
    return result.data;
  }

  async function axiosExtendLicense(licenseData){
    
    let result = {
      data:{}
    };
    
    try{
      result = await Axios.post(ExtendLicense,licenseData);     
    }catch(e){
      if(e.response){
        result.data = e.response.data;
      }  
    }
    return result.data;
  }

function * asyncReadLicense(arg){
  const callback = arg.payload.callback || (() => ({}));
  const code = arg.payload.code ;
  
  let res = {};

  res = yield call( axiosReadLicense , code)

  let licensePayload = initialState;
  
  if(res && res.status && res.data && res.data.pass){         
    licensePayload = {
        ...initialState,
        ...res.data.shopLicense
    }

    if(res.data.shopLicense.createDate){
      licensePayload.createDate = new Date(res.data.shopLicense.createDate);
      licensePayload.expDate = new Date(res.data.shopLicense.expDate);
    }

    if(res.data.shopLicense.merchant){
      let merchantValue = res.data.shopLicense.merchant
      licensePayload.merchantOption = {
        email: merchantValue.email,
        label: merchantValue.compName + '(' + merchantValue.progCode + ')' + '(' + merchantValue.email + ')'
      }
    }

   }else{
        res = {
            pass: false
        }         
    }
    yield put({ type: READ_LICENSE_SUCCESS, payload: licensePayload  });
    if(callback){
      callback(res)
  }

  


}


function* asyncPostLicense(arg) {     
  const callback = arg.payload.callback || (()=>({}));
  const editMode = arg.payload.editMode || 'create';
  const trialMode =  arg.payload.trial || false;
  const extendTrial = arg.payload.extendTrial || false;
  let storeLicenseData = yield select( state => state.licenseEdit);
  
  let res = {};  
  let licenseData = {
    ...storeLicenseData    
  }
  delete licenseData.licensePayments;
  delete licenseData.merchant;  
  //delete licenseData.merchantOption;

  licenseData.mode = editMode;
  licenseData.trial = trialMode;
  licenseData.extendTrial = extendTrial;

  if(licenseData.irev <= 0 || editMode == 'create'){
    res = yield call(
        axiosCreateLicense,licenseData
    );
   }else if(editMode == 'edit'){
    res = yield call(
        axiosEditLicense,licenseData
    ); 
   }else if(editMode == 'extend'){
    res = yield call(
      axiosExtendLicense,licenseData
    ); 
   }

  //  parseStdResponseError(res);

   let licensePayload = initialState;

   if(res && res.pass && res.info){         
    licensePayload = {
        ...initialState,
        ...res.info
    }
   }else{
        res = {
            pass: false,
            error:res.error
        } 
        licensePayload.irev = 0;
    }   
   if(callback){
        callback(res)
    }

  yield put({ type: SAVE_LICENSE_SUCCESS, payload: licensePayload  });
}

function* asyncCheckLicenseAmt(arg) {     
  
  const callback = arg.payload.callback || (()=>({}));  
  const editMode = arg.payload.editMode || 'create';
  //let licenseData = yield select( state => state.licenseEdit);


  let storeLicenseData = yield select( state => state.licenseEdit);
    
  let licenseData = {
    ...storeLicenseData    
  }
  licenseData.mode = editMode;
  licenseData.desc = '';
  delete licenseData.licensePayments;
  delete licenseData.merchant;
  delete licenseData.merchantOption;
  let data = {};    
  data = yield call(
      axiosCheckLicenseAmt,licenseData
  ); 
    let pass = false;
    
    if(data && data.classKey){
      //console.log(data);
      if(data.classKey === 'KppResponse'){
         pass = data.pass;
        if(!pass){                  
        }else{
          // console.log(data.info);
         
        }
      }
    }

  if(callback){
    callback(data)
  }

  if(pass)
    yield put({ type: CHECK_AMT_SUCCESS });

}


function* asyncAddLicensePayment(arg){
  const callback = arg.payload.callback || (()=>({}));  
  const uuid = arg.payload.uuid || '';
  const paymentMethod = arg.payload.paymentMethod || '';
 // let licenseData = yield select( state => state.licenseEdit);  

  let data = yield call(
    axiosAddPayment, uuid, paymentMethod
  )

  let pass = false;
    
  if(data && data.classKey){
    //console.log(data);
    if(data.classKey === 'KppResponse'){
       pass = data.pass;
      if(!pass){                  
      }else{
        // console.log(data.info);
       
      }
    }
  }

if(callback){
  callback(data)
}

if(pass)
  yield put({ type: ADD_LICENSEPAY_SUCCESS });
}


function* mySaga() {
  yield takeLatest(ASYNC_SAVE_LICENSE, asyncPostLicense);
  yield takeEvery(ASYNC_READ_LICENSE, asyncReadLicense);
  yield takeLatest(ASYNC_CHECK_AMT, asyncCheckLicenseAmt);
  yield takeLatest(ASYNC_ADD_LICENSEPAY, asyncAddLicensePayment);
  //yield takeLatest(UPDATE_LICENSE_EDIT, asyncCheckLicenseAmt);
}

export default mySaga;
